import { getTestAttributes } from '@chillibean/component-library';

function Button(props) {
  const {
    name,
    buttonType,
    actionType,
    disable,
    elementType,
    handleClick,
    href,
    formNoValidate,
    loadingIcon,
    dataTestId = `${name.toLowerCase()}-button`,
  } = props;

  const buttonTypeClass = `cta ${
    buttonType === 'primary'
      ? 'cta__primary'
      : buttonType === 'secondary'
      ? 'cta__secondary'
      : buttonType === 'light'
      ? 'cta__light'
      : ''
  }
  `;

  const handleOnClick = (event) => handleClick && handleClick(event);

  return (
    <>
      {elementType === 'link' ? (
        <a
          className={`${buttonTypeClass} ${disable ? 'disabled' : ''}`}
          onClick={(event) => {
            handleOnClick(event);
          }}
          href={href}
        >
          {name}
        </a>
      ) : (
        <button
          type={actionType}
          className={buttonTypeClass}
          disabled={disable}
          formNoValidate={actionType === 'submit' && formNoValidate}
          onClick={(event) => {
            handleOnClick(event);
          }}
          {...getTestAttributes(dataTestId)}
        >
          {name}
          {loadingIcon ? <i className="fa fa-spinner fa-spin" /> : null}
        </button>
      )}
    </>
  );
}

export default Button;
